<div class="container">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Section 6: Completed Application</h1>
        </div>
        <div class="col-16">
            <h2 class="head2-small">Online Enrollment Confirmation # {{confirmationNumber}}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p class="blue-text bottom-20">Gracias por su acuerdo verbal. Su solicitud de inscripción en Aetna ya está completa. ¿Tiene un bolígrafo y papel a mano para tomar nota del número de referencia de su solicitud de inscripción en Aetna y así tener una constancia?</p>
                <p class="qtip-note bottom-20"><strong>qTip Note:</strong> Provide system-generated confirmation number.</p>
                <p class="blue-text">Ahora, voy a presentar la solicitud en Medicare para su aprobación. Usted o La persona inscrita recibirá por correo postal una carta de acuse de recibo de la solicitud de inscripción en Aetna dentro de los siguientes 10 días calendario. Los beneficios que le correspondan entrarán en vigor el {{this.effectiveDate}}; esto queda sujeto a la aprobación de Medicare. Cuando Medicare apruebe su inscripción o la de la persona inscrita en Aetna, le enviaremos una carta de confirmación.</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <a class="link-button link print" routerLink="/enrollment/print" target="_blank" >Print a hard copy of the enrollment</a>
            <!--<button class="button primary" (click)="printHardCopy()">Print a hard copy of the enrollment Form >></button>-->
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <a class="link-button link pdf" (click)="SavePdf()">Save PDF of Completed Enrollment Data</a>
        </div>
    </div>
    <div class="row">
        <div class="col-7">
            <div class="wide">
                <button class="button primary bottom" (click)="enrollNew()">Enroll Another client at New Address</button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-7">
            <div class="wide">
                <button class="button primary" (click)="enrollSameAddress()">Enroll Another client at Same Address</button>
            </div>
        </div>
    </div>
</div>







